import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable, map, take } from 'rxjs';
import { GlobalStoreService } from '../../../../global/services/global-store.service';
import { Contact, Expertise } from '../../../interfaces/shared-interface';
import { LEGAL_LIST } from '../nav-data';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent implements OnInit {
  public date = new Date().getFullYear();
  public expertiseList$: Observable<Expertise[]> = this.globalStore.selectAllExpertises();
  public contactsList$: Observable<string[]> = this.globalStore.selectContacts().pipe(
    map((contacts: Contact[]) => {
      const uniqueLocations = new Set<string>();

      for (const contact of contacts || []) {
        const location = (
          contact.location ||
          contact.residenceName ||
          contact.descriptionAddress
        )?.trim();
        if (!location) {
          continue;
        }

        uniqueLocations.add(location);
      }

      return Array.from(uniqueLocations);
    })
  );
  public legalList = LEGAL_LIST;

  constructor(private globalStore: GlobalStoreService) {}

  ngOnInit(): void {
    this.globalStore
      .selectAllExpertises()
      .pipe(take(1))
      .subscribe((expertises: Expertise[]) => {
        if (!expertises?.length) {
          this.globalStore.fetchAllExpertises();
        }
      });

    this.globalStore
      .selectContacts()
      .pipe(take(1))
      .subscribe((contacts: Contact[]) => {
        if (!contacts?.length) {
          this.globalStore.fetchContacts();
        }
      });
  }
}
